export enum VendorQuestionnaireStatuses {
  Pending = 0, // Default state
  InProgress = 1, // Questionnaire sent and awaiting vendor action
  VendorSubmitted = 2, // Vendor submitted, awaiting review or acceptance
  Completed = 3, // Fully completed by assessor
  Expired = 4, // Link expired
  Cancelled = 5, // Cancelled by vendor or assessor
  Rejected = 6, // Submission rejected by assessor
  Resubmitted = 7, // Reopened for corrections
  ClarificationRequested = 8, // Assessor has requested clarification from vendor
}
